import React from 'react';
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';

import { decorateComponent } from '../../documentComponents';
import { Link } from './Link';
import { LinkInspector } from './LinkInspector';

export default decorateComponent(Link, 'inline', {
  id: 'a',
  label: '링크',
  defaultProps: {
    to: 'https://ohou.se',
    openOption: 'sameTab',
  },
  disallowedAncestors: [
    'a',
    'coupon',
    'tabButton',
  ],
  renderIcon: () => <BsLink45Deg />,
  renderInspector: LinkInspector,
});
